import { HslTicketPricing } from 'types/generatedSchemaTypes';
import { SelectedHslTicketStateProps } from 'types/states';
import { create } from 'zustand';

type HslState = {
  selectedHslPricing: HslTicketPricing | null;
  selectedHslTicket: SelectedHslTicketStateProps | null;
};

type HslActions = {
  setSelectedHslPricing: (pricing: HslTicketPricing | null) => void;
  setSelectedHslTicket: (ticket: SelectedHslTicketStateProps | null) => void;
};

export const useHslStore = create<HslState & HslActions>()((set) => ({
  selectedHslPricing: null,
  selectedHslTicket: null,
  setSelectedHslPricing: (pricing) => set({ selectedHslPricing: pricing }),
  setSelectedHslTicket: (ticket) => set({ selectedHslTicket: ticket }),
}));
